import './styles/global';
import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './root.component';
import { initGA } from './utils/google';

initGA();

ReactDOM.render(<Root />, document.getElementById('root'));
